import { IPlanType } from "../../../services/api/planEnrollment/types";
import { calculateMonthProratedAmount } from "@wingspanhq/utils/dist/date/banking";

type PlanTypes = Exclude<IPlanType, "MeridioHealth">;

const OAI_MONTHLY_PREMIUM = 3;
const PGLI_MONTHLY_PREMIUM = 80;
const PGLI_INITIATION_FEE = 50;

// reference here: https://github.com/wingspanHQ/benefits/blob/staging/src/lib/constants/planEnrollment.ts
export const PLAN_DETAILS: Record<
  PlanTypes,
  {
    name: string;
    monthlyPremium: number;
    monthlyPremiumFormatted: string;
    initiationFee?: number;
    initiationFeeFormatted?: string;
    claimsEmail?: string;
    claimsPhone: string;
    manageUrl?: string;
    claimsUrl?: string;
    eligibleProfessionLabel?: string;
    proratedPremium?: (date: Date) => number;
  }
> = {
  WingspanOccupationalAccidentInsurance: {
    name: "Wingspan Occupational Accident Insurance (OAI)",
    monthlyPremium: OAI_MONTHLY_PREMIUM,
    monthlyPremiumFormatted: `${OAI_MONTHLY_PREMIUM}%`,
    claimsPhone: "1-877-248-3455",
    claimsUrl:
      "https://web.intactspecialty.com/efnol?uniqueId=b5bd77d6-d0e1-4e2d-bf0b-bf845fbd9aae",
    manageUrl: `${window.location.origin}/member/my-resources/independent-contractor-insurance`
  },
  WingspanProfessionalLiabilityAndGeneralLiabilityInsurance: {
    name: "Wingspan Professional & General Liability Insurance (PL/GL)",
    monthlyPremium: PGLI_MONTHLY_PREMIUM,
    monthlyPremiumFormatted: `$${PGLI_MONTHLY_PREMIUM}`,
    initiationFee: PGLI_INITIATION_FEE,
    initiationFeeFormatted: `$${PGLI_INITIATION_FEE}`,
    proratedPremium: (date: Date) => {
      return calculateMonthProratedAmount(date, PGLI_MONTHLY_PREMIUM);
    },
    claimsEmail: "newclaims@markelcorp.com ",
    claimsPhone: "800-362-7535 (800-3MARKEL)",
    manageUrl: `${window.location.origin}/member/my-resources/independent-contractor-insurance`,
    eligibleProfessionLabel: "Independent Claims Adjusters"
  }
};

export const PGLI_KEY =
  "WingspanProfessionalLiabilityAndGeneralLiabilityInsurance" as const;

export const OAI_KEY = "WingspanOccupationalAccidentInsurance" as const;

export const PLAN_TYPES: PlanTypes[] = [PGLI_KEY, OAI_KEY];

export const MERIDIO_KEY = "health-insurance";
